import CurrencyInput from 'components/base/currency-input';
import { RequestItemType } from 'models/item-request.model';
import React, { useState } from 'react';
import { formatCurrency } from 'utils/functions';
import { FileUploader } from '@cokitchen/cokitchen-components';
import moment from 'moment';
import { FILE_UPLOADER_TOKEN } from 'utils/constants';
import { Dropdown, DropdownList } from '@cokitchen/cokitchen-components';
import { Calendar } from 'react-date-range';
import { ArrowDownIcon } from 'cokitchen-icons';

type PayloadValuesType = {
  quantity_received: number;
  quantity_requested: number;
  price_per_unit: number;
  invoiceUrls: string[];
  expiration_date: string;
};

interface MainstoreRequestItemReceiveProps {
  item: RequestItemType;
  onItemChange: (updatedItem: PayloadValuesType) => void;
}

const MainstoreRequestItemReceive = ({ item, onItemChange }: MainstoreRequestItemReceiveProps) => {
  const [errors, setErrors] = useState<Record<string, Record<string, string>>>({});
  const [totalPrice, setTotalPrice] = useState(0);
  const [showDateModal, setShowDateModal] = useState(false);
  const [localItem, setLocalItem] = useState({
    quantity_received: 0,
    quantity_requested: item.quantity,
    price_per_unit: 0,
    invoiceUrls: [''],
    expiration_date: new Date().toDateString()
  });
  const updateQuantityReceived = (value: string) => {
    if (Number(value) === localItem.quantity_received) return;
    if (Number(value) + Number(localItem.quantity_received) > Number(item.quantity)) {
      setErrors({
        ...errors,
        [item.ingredient_id]: {
          quantity_received: 'Quantity received cannot exceed quantity requested'
        }
      });
      return;
    }
    setErrors({
      ...errors,
      [item.ingredient_id]: {
        quantity_received: ''
      }
    });
    // Update local state with new quantity_received
    const updatedItem = {
      ...localItem,
      quantity_received: Number(value),
      price_per_unit: Number((totalPrice / Number(value)).toFixed(2))
    };
    setLocalItem(updatedItem);
    onItemChange(updatedItem);
  };
  return (
    <div className='ml-8'>
      <div key={item.id} className='flex gap-4 items-center font-medium mb-5'>
        <p className=''>{item?.ingredient?.name}</p>
        <p>{'Vendor Name'}</p>
      </div>
      <div className='w-full grid grid-cols-2 mb-6 gap-x-[28px] gap-y-10'>
        <div>
          <CurrencyInput
            label='Quantity received'
            placeholder='00'
            name='quantity_received'
            hasUnit
            unitValue={item.ingredient.unit_type}
            disableUnit
            hideCurrency
            value={localItem.quantity_received}
            onChange={updateQuantityReceived}
            error={errors?.[item.ingredient_id]?.quantity_received}
          />
          <p>
            Total Quantity received:
            <span className='text-blue-5 font-medium'>
              {' ' +
                Math.ceil(
                  Number(item.quantity_received || 0) + Number(localItem.quantity_received || 0)
                ) +
                ' ' +
                item.ingredient.unit_type}
            </span>
          </p>
        </div>

        <div>
          <CurrencyInput
            label='Actual price (Total)'
            placeholder='Actual price (Total)'
            name='price'
            value={totalPrice}
            onChange={(value) => {
              setTotalPrice(Number(value));
              const updatedItem = {
                ...localItem,
                price_per_unit: Number(
                  (Number(value) / Number(localItem.quantity_received)).toFixed(2)
                )
              };
              setLocalItem(updatedItem);
              onItemChange(updatedItem);
            }}
          />
          <p>
            Price per unit:
            <span
              className={` font-medium ${localItem.price_per_unit ? 'text-blue-5' : 'text-red-5'}`}>
              {localItem.price_per_unit
                ? formatCurrency(localItem.price_per_unit, { minimumFractionDigits: 5 })
                : ' 0'}
            </span>
          </p>
        </div>
        <div className='flex flex-col gap-1'>
          <span>Expiry Date</span>
          <Dropdown
            visible={showDateModal}
            onClickOutside={() => setShowDateModal(false)}
            content={
              <div
                className='w-full flex justify-between bg-gray-1/20 py-3.5 px-2 border-b-2 border-b-gray-3/60'
                onClick={() => setShowDateModal(!showDateModal)}>
                <p className={`text-sm ${localItem.expiration_date ? '' : 'text-gray-5'}`}>
                  {localItem.expiration_date
                    ? moment(localItem.expiration_date).format(' DD/MM/YY')
                    : 'Select a date (MM/YY)'}
                </p>
                <ArrowDownIcon className='w-5 h-5' />
              </div>
            }>
            <DropdownList className='!p-0 !max-h-fit'>
              <Calendar
                date={moment(localItem.expiration_date).toDate()}
                onChange={(item: Date) => {
                  setLocalItem({
                    ...localItem,
                    expiration_date: item.toDateString()
                  });
                }}
                showDateDisplay={() => setShowDateModal(true)}
                minDate={new Date()}
                className='calendar'
              />
            </DropdownList>
          </Dropdown>
        </div>
        <div className=''>
          <label>Upload invoice(s)</label>
          <FileUploader
            fileUrls={item?.invoiceUrls ? item?.invoiceUrls : []}
            setFileUrls={(imageUrls: any) => {
              setLocalItem({
                ...localItem,
                invoiceUrls: imageUrls
              });
            }}
            token={FILE_UPLOADER_TOKEN}
            className='w-full border-none p-0 m-0'
          />
        </div>
      </div>
    </div>
  );
};

export default MainstoreRequestItemReceive;
